module.exports = __webpack_public_path__ + "static/media/MegurimA.d0bd8da0.png";